import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Environment } from 'components/common/types/Environment.types';
import Local from 'modules/Local';

const initialState: Environment = {
  environmentId: Local.getEnvironmentId() || '',
};

const environmentSlice = createSlice({
  name: 'environment',
  initialState,
  reducers: {
    changeEnvironmentId: (state: Environment, action: PayloadAction<string>) => {
      return {
        ...state,
        environmentId: action.payload,
      };
    },
  },
});

export const { changeEnvironmentId } = environmentSlice.actions;
export default environmentSlice.reducer;
